var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.511C19.634 6.795 20.25 7.639 20.25 8.608V12.894C20.25 14.03 19.403 14.994 18.27 15.087C17.93 15.114 17.59 15.139 17.25 15.159V18.25L14.25 15.25C12.896 15.25 11.556 15.195 10.23 15.087C9.94133 15.0637 9.66053 14.9813 9.405 14.845M18.75 6.511C18.5955 6.46127 18.4358 6.42939 18.274 6.416C15.5959 6.19368 12.9041 6.19368 10.226 6.416C9.095 6.51 8.25 7.473 8.25 8.608V12.894C8.25 13.731 8.71 14.474 9.405 14.845M18.75 6.511V4.637C18.75 3.016 17.598 1.611 15.99 1.402C13.9208 1.13379 11.8365 0.999513 9.75 1C7.635 1 5.552 1.137 3.51 1.402C1.902 1.611 0.75 3.016 0.75 4.637V10.863C0.75 12.484 1.902 13.889 3.51 14.098C4.087 14.173 4.667 14.238 5.25 14.292V19L9.405 14.845",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/Meeting.ce694344919b8d81182a78d4135c906e.svg";
export { ForwardRef as ReactComponent };